import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { peopleEllipsisSx } from "../../peopleFormValidation";

export default function CustomerDetailInfoField({ icon: Icon, label, value, valueNode }) {
  const displayValue = value ?? "—";

  return (
    <Box sx={{ display: "flex", gap: 1.5, alignItems: "flex-start", minWidth: 0, width: "100%", overflow: "hidden" }}>
      <Box sx={{ 
        flexShrink: 0, 
        lineHeight: 0, 
        marginTop: label === "Role" ? 0 : (label === "Status" ? "-1px" : "-2px") 
      }}>
 
        <Icon />
      </Box>
      <Box sx={{ minWidth: 0, flex: 1, overflow: "hidden" }}>
        <Typography
          sx={{
            color: "#405261",
            fontFamily: "Inter",
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "18px",
            mb: "16px",
          }}
        >
          {label}
        </Typography>
        {valueNode ?? (
          <Typography
            component="div"
            title={typeof displayValue === "string" ? displayValue : undefined}
            sx={{
              color: "#061522",
              fontFamily: "Inter",
              fontSize: 16,
              fontWeight: 400,
              lineHeight: "18px",
              display: "block",
              width: "100%",
              ...peopleEllipsisSx,
            }}
          >
            {displayValue}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
